module.exports = __webpack_public_path__ + "static/media/eraser.1a1690f0.svg";